import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoCourseEvent } from "@/shared/model/edo-course-event.model";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../shared/reducers/entities/edo-course-event.reducer";

export interface DeleteEventoInsegnamentoProps {
  evento: IEdoCourseEvent;
  open: boolean;
  handleClose: (value?: boolean) => void;
}

export const DeleteEventoInsegnamento = (
  props: DeleteEventoInsegnamentoProps
) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector(
    (state) => state.edoCourseEvent
  );

  const { open, handleClose, evento } = props;

  const handleCloseDialog = () => {
    handleClose(false);
  };

  const confirmDelete = () => {
    dispatch(deleteEntity(evento.id));
  };

  useEffect(() => {
    if (updateSuccess) {
      handleCloseDialog();
    }
  }, [updateSuccess]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleCloseDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        {evento && (
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            <Translate
              contentKey="edocendoApp.edoCourseEvent.delete.question"
              interpolate={{ nome: evento.title }}
            >
              Are you sure you want to delete this EdoEventoInsegnamento?
            </Translate>
          </p>
        )}
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleCloseDialog}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
